import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { Checkbox } from "antd";
import { Controller } from "react-hook-form";
import AddLeadd from "../Modals/AddLeadd";
import DeleteLeadModal from "../Modals/DeleteLeadModal";
import { openModal } from "../../Redux/Slice/LoginSlice";
import { IconEye, IconPhone } from "@tabler/icons-react";

export const downloadCSV = (headers, data, fileName = "Failed_Records") => {
    // Convert headers to CSV format
    const csvRows = [];
    csvRows.push(headers.join(",")); // Add headers as the first row

    // Convert data to CSV format
    data?.forEach((row) => {
        const rowData = headers?.map((header) => {
            let cellValue = row[header] || ""; // Ensure empty cells are handled
            cellValue = String(cellValue).replace(/"/g, '""'); // Convert to string and escape double quotes
            return `"${cellValue}"`; // Wrap in double quotes
        });
        csvRows.push(rowData.join(",")); // Add row to CSV
    });

    // Create CSV content
    const csvContent = "\uFEFF" + csvRows.join("\n");

    // Convert to Blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${fileName}.csv`);
};

export const downloadTablePDF = (headers, data, fileName = "Leads_Report") => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text(fileName, 14, 15);

    // Define table headers
    const tableHeaders = headers?.map(header => ({ content: header, styles: { halign: 'center', fillColor: [255, 204, 0] } }));

    // Format data for table
    const tableData = data?.map(row => headers.map(header => row[header] || ""));

    // Add table
    doc.autoTable({
        startY: 25,
        head: [tableHeaders],
        body: tableData,
        theme: "grid",
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: { fillColor: [255, 204, 0] }, // Yellow background
    });

    // Save the PDF
    doc.save(`${fileName}.pdf`);
};

export const customStyles = {
    control: (provided, state) => ({
      ...provided,
      padding: "5px 10px",
      border: "2px solid rgba(228, 228, 231, 0.7)",
      borderRadius: "6px",
      outline: "none",
      caretColor: "#ef4444",
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      borderColor: state.isFocused ? "#007BFF" : "rgba(228, 228, 231, 0.7)",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 99999,
      position: "absolute",
    }),
  };

  export const getFilteredColumns = (tableColumns, allowedFields) => {

  const alwaysVisibleFields = [
    "select",
    "sr_no",
    "createdAt",
    "actions"
  ];

  if (!allowedFields || allowedFields.length === 0) {
    return tableColumns;
  }

  return tableColumns.filter((col) => {
    return (
      alwaysVisibleFields.includes(col.field) ||
      allowedFields.includes(col.field)
    );
  });
};
  
  
  export const onMenuOpen = (setIsMenuOpen) => () => setIsMenuOpen(true);
  export const onMenuClose = (setIsMenuOpen) => () => setIsMenuOpen(false);

  export const createLeadTableColumns = ({
  LeadsData,
  selectedRows,
  handleSelectAll,
  handleRowSelect,
  control,
  pageNo,
  records,
  userDetails,
  HandleViewLead,
  Company,
  AssignUsers,
  filterRecords,
  dispatch
}) => {
  return [
    {
      field: "select",
      header: LeadsData?.length > 0 && (
        <Checkbox
          checked={
            selectedRows?.length === LeadsData?.length && LeadsData?.length > 0
          }
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      style: true,
      className: "col-select",
      body: (row) => (
        <Controller
          name={`selected_${row.id}`}
          control={control}
          render={() => (
            <Checkbox
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleRowSelect(row._id, e.target.checked)}
            />
          )}
        />
      ),
    },
    {
      field: "sr_no",
      header: "Sr No",
      style: true,
      body: (row, meta) => (
        <h6>{(pageNo - 1) * Number(records) + meta.rowIndex + 1}</h6>
      ),
    },
    {
      field: "createdAt",
      header: "Created At",
      style: true,
      body: (row) => (
        <h6>{row?.createdAt ? row.createdAt.split("T")[0] : "-----"}</h6>
      ),
    },
    {
      field: "state",
      header: "State",
      style: true,
      body: (row) => <h6>{row?.state || "-----"}</h6>,
    },
    {
      field: "city",
      header: "City",
      style: true,
      body: (row) => <h6>{row?.city || "-----"}</h6>,
    },
    {
      field: "pincode",
      header: "Pincode",
      style: true,
      body: (row) => <h6>{row?.pincode || "-----"}</h6>,
    },
    {
      field: "firstName",
      header: "First Name",
      style: true,
      body: (row) => <h6>{row?.firstName || "-----"}</h6>,
    },
    {
      field: "lastName",
      header: "Last Name",
      style: true,
      body: (row) => <h6>{row?.lastName || "-----"}</h6>,
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => <h6>{row?.email || "-----"}</h6>,
    },
    {
      field: "phoneNumber",
      header: "Phone Number",
      style: true,
      body: (row) => <h6>{row?.phoneNumber || "----"}</h6>,
    },
    {
      field: "leadSource",
      header: "Lead Source",
      style: true,
      body: (row) => <h6>{row?.leadSource || "-----"}</h6>,
    },
    {
      field: "product",
      header: "Product",
      style: true,
      body: (row) => <h6>{row?.product || "-----"}</h6>,
    },
    userDetails?.role?.roleName === "SuperAdmin" && {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName || "-----"}</h6>,
    },
    {
      field: "alternateNumber",
      header: "Alternate Number",
      style: true,
      body: (row) => <h6>{row?.alternateNumber || "----"}</h6>,
    },
    {
      field: "assigned_to",
      header: "Assigned To",
      style: true,
      body: (row) => (
        <h6>
          {row?.assigned_to?.first_name && row?.assigned_to?.last_name
            ? `${row.assigned_to.first_name} ${row.assigned_to.last_name}`
            : "----"}
        </h6>
      ),
    },
    {
      field: "leadStatus",
      header: "Lead Status",
      style: true,
      body: (row) => <h6>{row?.leadStatus || "-----"}</h6>,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      body: (row) => <h6>{row?.remark || "-----"}</h6>,
    },
    {
      field: "fDate",
      header: "Fdate",
      style: true,
      body: (row) => <h6>{row?.fDate || "-----"}</h6>,
    },
    {
      field: "fTime",
      header: "Ftime",
      style: true,
      body: (row) => <h6>{row?.fTime || "-----"}</h6>,
    },
    {
      field: "lastCallDateTime",
      header: "Last call Date / Time",
      style: true,
      body: (row) => (
        <h6>
          {row?.lastCallDateTime
            ? moment(row?.lastCallDateTime).format("DD-MM-YYYY hh:mm:ss A")
            : "---"}
        </h6>
      ),
    },
    {
  field: "actions",
  header: "Actions",
  style: true,
  className: "col-actions",
  body: (row) => (
    <div className="flex items-center w-full gap-x-2">
      <button
        onClick={(e) => {
          e.preventDefault();
          HandleViewLead(row);
        }}
        className="py-1 rounded-lg flex justify-center w-1/2"
      >
        <IconEye stroke={1.5} size={24} color="#000" />
      </button>

      <AddLeadd
        edit={true}
        rowdata={row}
        Company={Company}
        iniAssignUsers={AssignUsers}
        filterRecords={() => filterRecords(true)}
      />

      {row?.assigned_to?.first_name && row?.assigned_to?.last_name && (
        <button
          onClick={(e) => {
            e.preventDefault();
            dispatch(
              openModal({
                isOpenModal: true,
                modalData: { rowdata: row },
              })
            );
          }}
        >
          <IconPhone stroke={1.5} size={18} color="#000"  />
        </button>
      )}

      {(userDetails?.role?.roleName === "SuperAdmin" ||
        userDetails?.role?.roleName === "Admin") && (
        <DeleteLeadModal
          row={row}
          filterRecords={() => filterRecords(true)}
        />
      )}
    </div>
  ),
},
  ].filter(Boolean);
};

export const truncateText = (text, maxLength = 20) => {
  if (!text) return "-----";

  const cleanText = text
    .toString()
    .replace(/\s+/g, " ")     // remove extra spaces
    .replace(/^,|,$/g, "")    // remove leading/trailing commas
    .trim();

  if (!cleanText) return "-----";

  return cleanText.length > maxLength
    ? cleanText.slice(0, maxLength).trim() + "..."
    : cleanText;
};